import { render } from "./AlertList.vue?vue&type=template&id=2b576126&scoped=true"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"

import "./AlertList.vue?vue&type=style&index=0&id=2b576126&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b576126"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpace,QBtn,QDialog});
